import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useInitiatePasswordResetMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ emailAddress }: { emailAddress: string }) =>
			userSession.webServiceHelper.callWebServiceAsync(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: {
						emailAddress,
					},
					urlPath: `user/initiatePasswordReset`,
				}),
				'POST',
				undefined,
				null
			),
		onError,
		onSuccess,
	});
}
